














































import { ValidationProvider, ValidationObserver } from "vee-validate";
import { Vue, Component, Prop } from "vue-property-decorator";
import ebButton from "@/components/FormElements/Button.vue";
@Component({
  components: {
    ebButton,
    ValidationProvider,
    ValidationObserver,
  },
})
export default class Create extends Vue {
  private name: string = "";
  private description: string = "";
  private resetKey: number = 0;

  private async createNewRole() {
    const isValid = await this.$refs.observer.validate();
    if (!isValid) return;
    this.$emit("newRole", { name: this.name, description: this.description });
    this.name = "";
    this.description = "";
    this.resetKey++;
  }
}
